module.exports = __webpack_public_path__ + "dummyRoundProfile.png";